module.exports = __webpack_public_path__ + "media/images/logo-ef20f2570ea0e93675339f769608cff7.png";